// ===== Request Types =====

export interface LoginInRequest {
  loginId: string
  password: string
}


export interface TokenResponse {
  access_token: string
}


export interface Self {
  id: number,
  loginId: string
  name: string
  email: string
  createdAt:string
}

// ===== 비밀번호 찾기 (인증번호 재설정) =====

export interface RequestPasswordResetCodeRequest {
  email: string
}

export interface VerifyPasswordResetCodeRequest {
  email: string
  verificationCode: string
}

export interface VerifyPasswordResetCodeResponse {
  resetToken: string
}

export interface ResetPasswordRequest {
  resetToken: string
  newPassword: string
  newPasswordConfirm: string
}
// ===== Storage Service =====

export class StorageService {

  static setTokens(token: string): void {
    if (typeof window === 'undefined') return
    localStorage.setItem('access_token', token)
  }

  static clearTokens(): void {
    if (typeof window === 'undefined') return
    localStorage.removeItem('access_token')
  }
}